import cx from 'classnames'
import { State } from 'stores/Workflows/State'
import Styles from './WorkflowBuilderItem.module.scss'
import { Form } from './Form'
import { Divider } from './Divider'
import { ActionPicker } from './ActionPicker'
import { ConnectionLine } from './ConnectionLine'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  states: State[]
}

export const Body = ({ states }: Props) => {
  const [state, connectedState] = states
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.body}>
      {states.length === 2 && <ConnectionLine />}
      <div className={cx(Styles.formContainer, { [Styles.twoRows]: states.length === 2 })}>
        <div>
          <Form key={state.position} state={state} />
          {connectedState && <Form key={connectedState.position} state={connectedState} />}
        </div>
        {!isMobile && <Divider />}
        <div className={Styles.configFieldSet}>
          {state.isDefault ? (
            <span className={Styles.defaultStatus}>Default Status</span>
          ) : (
            <ActionPicker state={state} onSelectionChange={state.setEntryAction} />
          )}
        </div>
      </div>
    </div>
  )
}
